import React from "react";

const getBarColor = (percentage) => {
  if (percentage >= 100) {
    return "#00B136";
  }
  if (percentage >= 90 && percentage < 100) {
    return "#FF9800";
  }
  return "#E2136E";
};

const PercentageBar = ({ percentage }) => (
  <div
    style={{
      width: "100%",
      padding: "4px",
      background: "#F3F5FA",
      borderRadius: 16,
      boxShadow: "2px 2px 4px 0px rgba(54, 43, 115, 0.08) inset",
      filter: "drop-shadow(2px 2px 1px 0px rgba(255, 255, 255, 1))",
    }}
  >
    <div
      style={{
        width: `${Math.min(percentage, 100)}%`,
        background: getBarColor(percentage),
        height: 16,
        borderRadius: 16,
        minWidth: percentage > 0 ? 4 : 0,
        transition: "width 0.4s ease",
      }}
    />
  </div>
);

export default PercentageBar;
